// File: EmailSideMenu.jsx
import React, { useEffect, useState } from "react";
import FormTemplate from "../../../forms/FormTemplate";
import {
  Box,
  Button,
  Stack,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { useParams } from "react-router-dom";
import ROUTES from "../../../routerfolder/Routes";
import EmailTemplateSelection from "./EmailTemplateSelection";
import useAutomations from "../../../hooks/automationhooks/useAutomations";

export default function EmailSideMenu({
  onClose,
  onSubmit,
  selectedNode,
  preSelectedTemplate = null,
  isDrawer = false,
}) {
  const { brandId } = useParams();
  const { isLoading, emails, handleGetEmails } = useAutomations();
  const [templateSelectionOpen, setTemplateSelectionOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(preSelectedTemplate);

  useEffect(() => {
    handleGetEmails(brandId);
  }, [brandId]);

  useEffect(() => {
    // only run after templates have been fetched
    if (!isLoading && selectedNode?.data?.id) {
      // emails.data is your array of templates
      const match = emails.data.find(
        (tmpl) => tmpl.Id === selectedNode.data.id
      );
      if (match) {
        setSelectedTemplate(match);
      }
    }
  }, [isLoading, emails.data, selectedNode]);

  const handleTemplateSelect = (tmpl) => {
    setSelectedTemplate(tmpl);
    setTemplateSelectionOpen(false);
  };

  const handleSubmitLocal = () => {
    const data = {
      label: "Email Message",
      id: selectedTemplate.Id,
      name: selectedTemplate.Name,
    };
    onSubmit(data);
    onClose();
  };

  return (
    <>
      {isLoading && <Typography>Loading Email Templates...</Typography>}
      {!isLoading && (
        <FormTemplate
          title={selectedNode ? "Edit Email" : "Create Email"}
          isValid={selectedTemplate}
          onClose={onClose}
          handleSubmit={handleSubmitLocal}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              height: "100%",
            }}
          >
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                color="companyBlue"
                disabled={!emails.data || !emails.data.length}
                sx={{ textTransform: "none", borderRadius: 2 }}
                onClick={() => setTemplateSelectionOpen(true)}
              >
                Select Template
              </Button>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", borderRadius: 2 }}
                onClick={() =>
                  window.open(
                    "#" +
                      ROUTES.TEMPLATES.replace(
                        ":TemplateType",
                        "Email"
                      ).replace(":brandId", brandId),
                    "_blank",
                    "noopener"
                  )
                }
              >
                Create Template
              </Button>
            </Stack>

            {selectedTemplate ? (
              <Box>
                <Typography>Selected Template:</Typography>
                <Box
                  sx={{
                    border: 1,
                    borderRadius: 1,
                    p: 2,
                    overflowY: "auto",
                    flexGrow: 1,
                  }}
                >
                  {
                    <img
                      src={selectedTemplate.ImageSrc}
                      alt={selectedTemplate.Name}
                    />
                  }
                </Box>
              </Box>
            ) : (
              <Box>
                {emails.count ? (
                  <Typography>No Template Selected</Typography>
                ) : (
                  <Typography>No Emails Found</Typography>
                )}
              </Box>
            )}
          </Box>
        </FormTemplate>
      )}

      <EmailTemplateSelection
        open={templateSelectionOpen}
        setSelected={handleTemplateSelect}
        setClosed={() => setTemplateSelectionOpen(false)}
        templates={emails?.data || []}
        refreshTemplates={() => handleGetEmails(brandId)}
        isDrawer={isDrawer}
      />
    </>
  );
}
